"use strict";
// Copyright © 2021 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SingleContactDataForm = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const backoffice_1 = require("../../../dsl/backoffice");
let SingleContactDataForm = class SingleContactDataForm extends vue_property_decorator_1.Vue {
    get description() {
        return this.contactData.description.replace(/<br \/>/g, '\n');
    }
    set description(value) {
        const _encodedString = value.replace(/[\r\n]+/gm, '<br />');
        this.contactData.description = _encodedString;
    }
};
__decorate([
    vue_property_decorator_1.Prop({ type: Object, required: true }),
    __metadata("design:type", Object)
], SingleContactDataForm.prototype, "contactData", void 0);
SingleContactDataForm = __decorate([
    vue_property_decorator_1.Component({
        name: 'SingleContactDataForm',
        components: {
            DashmixInput: backoffice_1.DashmixInput,
            DashmixTextArea: backoffice_1.DashmixTextArea
        },
        template: `
    <div class="bg-gray-light p-3 w-100 figure-with-btn__image">
    <DashmixInput
      class="mb-2"
      :placeholder="$t('forms.contact.tabs.contactData.titlePlaceholder')"
      :model.sync="contactData.title"
      :name="contactData.title"
    />
    <DashmixTextArea
      :placeholder="$t('forms.contact.tabs.contactData.descriptionPlaceholder')"
      :model.sync="description"
      :name="contactData.description"
      style="resize: none"/>
    </div>
  `
    })
], SingleContactDataForm);
exports.SingleContactDataForm = SingleContactDataForm;
//# sourceMappingURL=SingleContactDataForm.js.map